// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__353FU","right":"Footer_right__2zHJQ","buttons":"Footer_buttons__3vaxf"};